import React, { useEffect, useState } from "react";
import {
  formatDateTime,
  getQueryParams,
  mergeParams,
} from "../../helpers/helpers";
import api from "../../services/api";
import Form from "../../components/form";

import { CircularProgress, Divider } from "@mui/material";
import { Box } from "@mui/material";
import { TableContainer } from "@mui/material";
import { Table } from "@mui/material";
import { TableRow } from "@mui/material";
import { TableCell } from "@mui/material";
import { TableHead } from "@mui/material";
import { TableBody } from "@mui/material";
import { Dialog } from "@mui/material";
import { DialogContent } from "@mui/material";
import { DialogContentText } from "@mui/material";
import { Grid } from "@mui/material";
import { ThemeProvider } from "@mui/material";
import { Button } from "@mui/material";
import { DialogActions } from "@mui/material";
import { createTheme } from "@mui/material";
import { Page, Text, View, Document, StyleSheet, PDFViewer, PDFDownloadLink} from '@react-pdf/renderer';

export default function Coordenacao({ history, location }) {
  const [dadosProfissional, setDadosProfissional] = useState({});
  const [itemSelecionado, setItemSelecionado] = useState(false);
  const [dadosRelatorios, setDadosRelatorios] = useState([]);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [escolaNome, setEscolaNome] = useState('');
  const [dadosFiltros, setDadosFiltros] = useState(
    mergeParams(
      {
        escolaId: "",
        apenasRegentes: true,
      },
      location
    )
  );

  useEffect(() => {
    carregarComboEscolas();

    if (dadosFiltros.escolaId || dadosFiltros.apenasRegentes) {
      carregarRelatorio();
    }
  }, []);

  const carregarComboEscolas = () => {
    api
      .get("escolas/listar", { ativas: true })
      .then((comboEscolas) => setComboEscolas(comboEscolas));
  };

  const carregarRelatorio = (filtrosEnviar = dadosFiltros) => {
    setDadosFiltros(filtrosEnviar);
    setCarregando(true);
    const ciclos = [];

    api
      .get("relatorios/participacaoCoordenadoria", filtrosEnviar)
      .then((retorno) => {
        const { registros, escolaId } = retorno;

        if(registros[0]) setEscolaNome(registros[0].escolaNome);

        registros.forEach((r) => {
          const cicloLocalizado = ciclos.filter((c) => c.id === r.cicloId);

          if (cicloLocalizado.length === 0) {
            ciclos.push({
              id: r.cicloId,
              nome: r.cicloNome,
            });
          }
        });

        ciclos.sort((a, b) => {
          if (a.nome > b.nome) return 1;

          return -1;
        });

        const dadosCiclo = [];

        ciclos.forEach((c) =>
          dadosCiclo.push(registros.filter((r) => r.cicloId === c.id))
        );

        const relatorios = [];

        dadosCiclo.forEach((dc) => {
          const profissionais = [];
          const unidades = [];

          dc.forEach((registro) => {
            const profissionalLocalizado = profissionais.filter(
              (p) => p.id === registro.usuarioId
            );

            if (profissionalLocalizado.length === 0) {
              profissionais.push({
                id: registro.usuarioId,
                nome: registro.usuarioNome,
              });
            }

            const unidadeLocalizada = unidades.filter(
              (u) => u.id === registro.unidadeId
            );

            if (unidadeLocalizada.length === 0) {
              unidades.push({
                id: registro.unidadeId,
                titulo: registro.unidadeTitulo,
                numero: registro.unidadeNumero,
                titulo: registro.unidadeTitulo,
                cicloId: registro.cicloId,
                cicloNome: registro.cicloNome,
              });
            }
          });

          const qtdGrupos = Math.ceil(profissionais.length / 8);

          for (var i = 1; i <= qtdGrupos; i++) {
            //Quando há muitos profissionais, destrincha o relatório
            const grupoProfissionais = profissionais.slice(i * 8 - 8, i * 8);

            const relatorio = gerarRelatorio(
              dc,
              grupoProfissionais,
              unidades,
              i,
              qtdGrupos
            );

            relatorios.push(relatorio);
          }
        });
        setCarregando(false);

        setDadosRelatorios(relatorios);
      });
  };

  const gerarRelatorio = (
    dadosCiclo,
    profissionais,
    unidades,
    numGrupo,
    qtdGrupos
  ) => {
    const titulo = dadosCiclo[0]
      ? `${dadosCiclo[0].cicloNome} - (${numGrupo}/${qtdGrupos})`
      : "";
    const colunas = [];
    const linhas = [];
    let linha = [];

    colunas.push({ valor: "Unidade", tipo: "UNIDADE" });

    colunas.push({ valor: "Nº", tipo: "NUMERO" });

    profissionais.forEach((p) => {
      const nomes = p.nome.split(" ");

      const nome = `${nomes[0]}\n${nomes[nomes.length - 1]}`;

      colunas.push({
        valor: nome,
        tooltip: p.nome,
      });
    });

    unidades.forEach((u) => {
      linha = [];

      linha.push({
        tipo: "UNIDADE",
        valor: u.titulo,
      });

      linha.push({
        tipo: "",
        valor: u.numero,
      });

      profissionais.forEach((p) => {
        const profissionalLocalizado = dadosCiclo.filter(
          (r) => r.usuarioId === p.id && r.unidadeId === u.id
        );

        const registroProfissional =
          profissionalLocalizado.length > 0 ? profissionalLocalizado[0] : {};

        const { situacao, situacaoId, previsaoInicio, inicio, termino } =
          registroProfissional;

        linha.push({
          tipo: "REGISTRO",
          valor: situacao,
          id: situacaoId,
          detalhes: {
            profissional: p.nome,
            unidade: u.titulo,
            previsaoInicio,
            inicio,
            termino,
            situacao,
          },
          tooltip: `${p.nome}: ${situacao}`,
        });
      });

      linhas.push(linha);
    });

    return {
      titulo,
      colunas,
      linhas,
    };
  };

  const filtros = {
    title: "Filtros",
    form: {
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        space: 8,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: dadosFiltros.escolaId,
      },
      apenasRegentes: {
        label: "Apenas regentes",
        type: "check",
        space: 2,
        value: dadosFiltros.apenasRegentes,
      },
    },

    submit: {
      label: "Carregar",
      action: carregarRelatorio,
    },

    urlParams: true,
    history,
    location,
  };

  const detalhar = (detalhes) => {
    setItemSelecionado(true);
    setDadosProfissional(detalhes);
  };

  const handleClose = () => {
    setItemSelecionado(false);
    setDadosProfissional({});
  };

  return (
    <div>
      <Form formData={filtros} />
      <br />

      {dadosRelatorios.length > 0 && (
        <>
        {dadosRelatorios.length > 0 &&
            <PDFDownloadLink 
                document={
                    <MyDocument 
                        relatorios={dadosRelatorios} 
                        escolaNome={escolaNome}
                        dataHora={new Date().toLocaleString()}
                    />
                } 
                fileName={`participacao_${escolaNome}.pdf`}
            >
                {({ blob, url, loading, error }) => (loading ? 'Loading document...' : <DownloadPdfButton/>)}
            </PDFDownloadLink>
          } 
          {dadosRelatorios.map((relatorio, index) => (
            <Box
              sx={{
                width: "100%",
                bgcolor: "background.paper",
                marginBottom: 5,
              }}
            >
              <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      {relatorio.titulo}
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <Divider />
                    <TableRow>
                      {relatorio.colunas.map((coluna) => (
                        <TableCell
                          sx={{ background: "#F4F7FA", fontWeight: "bold" }}
                          component="th"
                          scope="row"
                        >
                          {coluna.valor}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relatorio.linhas.map((linha) => (
                      <TableRow
                        hover
                        // key={coluna.valor}
                        sx={{
                          cursor: "pointer",
                          background: ":hover: #F4F7FA",
                        }}
                      >
                        {linha.map((linha, key) => (
                          <TableCell component="th" scope="row">
                            {/* {linha.valor} */}
                            {desenharCelula(linha, key, detalhar)}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ))}
          <Box
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              marginBottom: 5,
            }}
          >
            <TableContainer>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Legenda</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow sx={{ background: "#F4F7FA" }}>
                    <TableCell>Situação</TableCell>
                    <TableCell>Descrição</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bolder", color: "gray" }}
                      component="th"
                      scope="row"
                    >
                      Não iniciado
                    </TableCell>
                    <TableCell>Acompahamento ainda não iniciado.</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bolder", color: "black" }}>
                      Em andamento
                    </TableCell>
                    <TableCell component="th" scope="row">
                      Acompanhamento iniciado e dentro do prazo.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bolder", color: "green" }}>
                      Finalizado
                    </TableCell>
                    <TableCell component="th" scope="row">
                      Acompanhamento finalizado.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bolder", color: "orange" }}>
                      Atrasado para finalizar
                    </TableCell>
                    <TableCell component="th" scope="row">
                      Acompanhamento já iniciado, porém atrasado para finalizar.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bolder", color: "red" }}>
                      Atrasado para iniciar
                    </TableCell>
                    <TableCell component="th" scope="row">
                      Acompanhamento não iniciado e fora do prazo.
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      )}

      <Dialog
        open={itemSelecionado}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <h3>Detalhes</h3>
          <br />

          <DialogContentText id="alert-dialog-description">
            <Grid container style={{ paddingLeft: 15 }}>
              <Grid item xs={12}>
                <h4>Profissional</h4>
              </Grid>
              <Grid item xs={12}>
                <p>{dadosProfissional.profissional}</p>
              </Grid>
              <br />
              <br />

              <Grid item xs={12}>
                <h4>Unidade</h4>
              </Grid>
              <Grid item xs={12}>
                <p>{dadosProfissional.unidade}</p>
              </Grid>
              <br />
              <br />

              <Grid item xs={12}>
                <h4>Previsão de início</h4>
              </Grid>
              <Grid item xs={12}>
                <p>
                  {formatDateTime(dadosProfissional.previsaoInicio, "D/M/Y")}
                </p>
              </Grid>
              <br />
              <br />

              <Grid item xs={12}>
                <h4>Início</h4>
              </Grid>
              <Grid item xs={12}>
                <p>
                  {dadosProfissional.inicio
                    ? formatDateTime(dadosProfissional.inicio, "D/M/Y h:m")
                    : "Não iniciado"}
                </p>
              </Grid>
              <br />
              <br />

              <Grid item xs={12}>
                <h4>Término</h4>
              </Grid>
              <Grid item xs={12}>
                <p>
                  {dadosProfissional.termino
                    ? formatDateTime(dadosProfissional.termino, "D/M/Y h:m")
                    : "Não finalizado"}
                </p>
              </Grid>
              <br />
              <br />

              <Grid item xs={12}>
                <h4>Situação</h4>
              </Grid>
              <Grid item xs={12}>
                <p>{dadosProfissional.situacao}</p>
              </Grid>
              <br />
              <br />
            </Grid>
          </DialogContentText>
        </DialogContent>
        <ThemeProvider theme={theme}>
          <Button
            style={{ margin: "0px 10px 0px 10px" }}
            variant="contained"
            sx={{ color: "#FFFF" }}
            onClick={handleClose}
          >
            Fechar
          </Button>
        </ThemeProvider>

        <DialogActions></DialogActions>
      </Dialog>
    </div>
  );
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#fa9702",
      color: "white",
    },
  },
});

const desenharCelula = (registro, key, detalhar) => {
  switch (registro.tipo) {
    case "UNIDADE":
      return (
        <td key={key} style={{ fontWeight: "bolder" }}>
          {registro.valor}
        </td>
      );

    case "REGISTRO":
      switch (registro.id) {
        case 1:
          return (
            <td
              key={key}
              style={{ fontWeight: "bolder", color: "gray" }}
              title={registro.tooltip}
            >
              <div onClick={() => detalhar(registro.detalhes)}>Aguardando</div>
            </td>
          );

        case 2:
          return (
            <td
              key={key}
              style={{ fontWeight: "bolder", color: "black" }}
              title={registro.tooltip}
            >
              <div onClick={() => detalhar(registro.detalhes)}>
                Em andamento
              </div>
            </td>
          );

        case 3:
          return (
            <td
              key={key}
              style={{ fontWeight: "bolder", color: "green" }}
              title={registro.tooltip}
            >
              <div onClick={() => detalhar(registro.detalhes)}>Finalizado</div>
            </td>
          );

        case 4:
          return (
            <td
              key={key}
              style={{ fontWeight: "bolder", color: "orange" }}
              title={registro.tooltip}
            >
              <div onClick={() => detalhar(registro.detalhes)}>Atrasado</div>
            </td>
          );

        case 5:
          return (
            <td
              key={key}
              style={{ fontWeight: "bolder", color: "red" }}
              title={registro.tooltip}
            >
              <div onClick={() => detalhar(registro.detalhes)}>Atrasado</div>
            </td>
          );

        default:
          return (
            <td
              key={key}
              style={{ fontWeight: "bolder", color: "red" }}
              title={registro.tooltip}
            >
              <div onClick={() => detalhar(registro.detalhes)}>
                {registro.valor}
              </div>
            </td>
          );
      }

    default:
      return <td key={key}>{registro.valor}</td>;
  }
};

const MyDocument = ({relatorios, escolaNome, dataHora}) => (
  <Document>
      {relatorios.map((relatorio, key) => (
          <Page size="A4" style={styles.page} orientation="landscape">
              <View style={styles.titulo}>
                  <Text>{`${relatorio.titulo} - ${escolaNome} (${dataHora})`}</Text>
              </View>
              <View style={styles.cabecalho}>
                  {relatorio.colunas.map((coluna, key) => {
                      switch(coluna.tipo){
                          case 'UNIDADE':
                              return(
                                  <View style={styles.textoUnidade}>
                                      <Text>{coluna.valor}</Text>
                                  </View>
                              );
                          case 'NUMERO':
                              return(
                                  <View style={styles.textoNumero}>
                                      <Text style={{color: 'black'}}>{coluna.valor}</Text>
                                  </View>
                              );
                          default:
                              return(
                                  <View style={styles.textoTitulo}>
                                      <Text>{coluna.valor}</Text>
                                  </View>
                              );
                      }
                  })}
              </View>
              {relatorio.linhas.map((linha, key) => (
                  <View style={styles.linhaRegistro} key={key}>
                      {linha.map(registro => {
                          switch(registro.tipo) {
                              case 'UNIDADE':
                                  return (
                                      <View style={styles.textoUnidade}>
                                          <Text>{registro.valor}</Text>
                                      </View>
                                  );
                      
                              case 'REGISTRO':
                                  return (
                                      <View style={styles.textoTitulo}>
                                          <Text style={{color: definirCorRegistro(registro.id)}}>{registro.valor}</Text>
                                      </View>
                                  );

                              default:
                                  return (
                                      <View style={styles.textoNumero}>
                                          <Text>{registro.valor}</Text>
                                      </View>
                                  );
                      }})}
                  </View>
              ))}
        </Page>
      ))}
  </Document>
);

const DownloadPdfButton = () => (
  <Button 
      variant="raised" 
      color="primary" 
      className="mr-10 mb-10 text-white btn-icon"
  >
      Download PDF 
      <i className="zmdi zmdi-download"></i>
  </Button>
);

const styles = StyleSheet.create({
  page: { backgroundColor: 'white', marginHorizontal: 20 },
  titulo: { color: 'black', textAlign: 'center', margin: 20, fontSize: 15 },
  textoTitulo: {fontWeight: 'bold', width: '60px', marginHorizontal: 10},
  textoNumero: {width: '20px', marginHorizontal: 6, color: 'gray'},
  textoUnidade: {width: '110px', marginHorizontal: 7},
  cabecalho: {fontSize: 12, flexDirection: "row", borderStyle: 'solid', borderBottom: 1, marginBottom: 5, paddingBottom: 2},
  linhaRegistro: {fontSize: 12, flexDirection: "row", marginVertical: 5, minHeight: '10px'}
});

const definirCorRegistro = (id) => {
  switch(id){
      case 1:
          return 'gray';
      case 2:
          return 'black';
      case 3:
          return 'green';
      case 4:
          return 'orange';
      case 5:
          return 'red';
      default:
          return 'black';
  }
}